import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'

import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { IsTrustedPartnerContextProvider } from '@modules-deprecated/app/umbrellas'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { StripeOverdueInvoiceLockedView } from '@views/stripeOverdueInvoiceLockedView/StripeOverdueInvoiceLockedView'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'stripe-overdue-invoice-locked-box'

class StripeOverdueInvoiceLockedBoxWebComponent extends DOMModel {
  @byAttrVal organizationid: string
}

type Props = {
  organizationid: string
}

function StripeOverdueInvoiceLockedBoxModule({ organizationid }: Props): ReactElement {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <UserOrganizationSettingsContextProvider organizationId={organizationid}>
          <UserOrganizationContextProvider organizationId={organizationid}>
            <IsTrustedPartnerContextProvider organizationId={organizationid}>
              <CurrentUserContextProvider>
                <ModalContextProvider>
                  <StripeOverdueInvoiceLockedView />
                </ModalContextProvider>
              </CurrentUserContextProvider>
            </IsTrustedPartnerContextProvider>
          </UserOrganizationContextProvider>
        </UserOrganizationSettingsContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const StripeOverdueInvoiceLockedBoxElement = createCustomElement(
  StripeOverdueInvoiceLockedBoxModule,
  StripeOverdueInvoiceLockedBoxWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, StripeOverdueInvoiceLockedBoxElement)

export default StripeOverdueInvoiceLockedBoxElement
